function cleanText(text = "") {
    return text.replace(/\\n|[\n\r]/g, "").trim();
  }

  // function normalizeTrueFalse(question) {
  //   // return {
  //   //   type: "truefalse",
  //   //   questionText: cleanText(question.question || question.Question || ""),
  //   //   answerText: cleanText(question.answer || question.Answer || ""),
  //   //   correctSentence: cleanText(question.correctSent || ""),
  //   //   index: question.index ?? null,
  //   //   originalSentence: cleanText(question.originalSentence || ""),
  //   // };
  //   return {
  //     type: "truefalse",
  //     questionText: cleanText(question.question || question.Question || ""),
  //     answerText: cleanText((question.answer || question.Answer || "").toLowerCase()),
  //     correctSentence: cleanText(question.correctSent || ""),
  //     index: question.index ?? null,
  //     originalSentence: cleanText(question.originalSentence || ""),
  //     trueOption: cleanText(question.true_option || question.True_Option || "True"),
  //     falseOption: cleanText(question.false_option || question.False_Option || "False"),
  //   };
  // }

  function normalizeTrueFalse(question) {
    // If the question is already in old format (no questionList), return it directly (after cleaning)
  if (!Array.isArray(question.questionList)) {
    return {
      question: cleanText(question.question || question.Question || ""),
      answer: cleanText(question.answer || question.Answer || ""),
      correctSent: cleanText(question.correctSent || ""),
      originalSentence: cleanText(question.originalSentence || ""),
      index: question.index ?? null,
    };
  }

  // New format: pick a random question from questionList
  const randomIndex = Math.floor(Math.random() * question.questionList.length);
  const randomQ = question.questionList[randomIndex];

  return {
    question: cleanText(randomQ.question || ""),
    answer: cleanText(randomQ.answer || ""),
    correctSent: cleanText(randomQ.correctSent || ""),
    originalSentence: cleanText(question.originalSentence || ""),
    index: question.index ?? null,
  };
  }

  function normalizeMCQ(question) {
    const options = question.options || question.Options || [];
    return {
      type: "mcq",
      question: cleanText(question.question || question.Question || ""),
      answer: cleanText(question.answer || question.Answer || ""),
      options: options.map(cleanText),
      index: question.index ?? question.index,
    };
  }

  function normalizeFIB(question) {
    return {
      type: "fib",
      question: cleanText(question.question || question.Question || ""),
      blanks: question.blanks || [],
      answer: cleanText(question.answer || question.Answer || ""),
      index: question.index ?? question.index,
    };
  }

  function normalizeQA(question) {
    // Case 1: Old format – no type field needed
    if (question.question && question.answer) {
      return {
        question: cleanText(question.question),
        answer: cleanText(question.answer),
      };
    }
  
    // Case 2: New format – include type field
    if (question.Question && question.Answer) {
      return {
        type: "qa",
        question: cleanText(question.Question),
        answer: cleanText(question.Answer),
        originalSentence: cleanText(question.originalSentence || ""),
      };
    }
  
    // Fallback: unknown format
    return {
      question: "",
      answer: "",
    };
  }

  function normalizeInptQA (question) {
    console.log(Object.keys(question));

     // If input is a single object, wrap it in an array
  const questionsArray = Array.isArray(question) ? question : [question];

  // Process each object
  return questionsArray
    .map((q) => {
      const qText = q.question || q.Question;
      const aText = q.answer || q.Answer;

      if (qText && aText) {
        return {
          type: q.Question && q.Answer ? "interpretive" : undefined,
          question: cleanText(qText),
          answer: cleanText(aText),
          originalSentence: cleanText(q.originalSentence),
        };
      }

      console.log("questionsArray in Interpretive :",questionsArray);
      return null; // skip if no valid QA pair
    })
    .filter(Boolean); // remove nulls
    //  // Case 1: Old format – no type field needed
    //  if (question.question && question.answer) {
    //   return {
    //     question: cleanText(question.question),
    //     answer: cleanText(question.answer),
    //   };
    // }
  
    // if (question.Question && question.Answer) {
    //   return {
    //     type: "interpretive",
    //     question: cleanText(question.Question),
    //     answer: cleanText(question.Answer),
    //     originalSentence: cleanText(question.originalSentence || ""),
    //   };
    // }
  
    // // Fallback: unknown format
    // return {
    //   question: "",
    //   answer: "",
    // };
  }
  
  function normalizeQuestion(question, type) {
    switch (type.toLowerCase()) {
      case "truefalse":
        return normalizeTrueFalse(question);
      case "mcq":
        return normalizeMCQ(question);
      case "fib":
        return normalizeFIB(question);
      case "qa":
        return normalizeQA(question);  
      case "interpretive":
        return normalizeInptQA(question);
      default:
        return { error: "Unknown question type" };
    }
  }

  export { normalizeQuestion , cleanText };